export default "__VITE_ASSET__DfGKOiTQ__"